import { ChangeDetectorRef } from '@angular/core';
import { Component, Output, EventEmitter, Input } from '@angular/core';
import { Keyboard } from '@ionic-native/keyboard';
import { Observable } from 'rxjs';
import { Events } from 'ionic-angular';
import { EVENTS_NAME } from '../../../providers/myria/app-variables';
import { ColorProvider } from '../../../providers/color/color';

declare let cordova;

@Component({
  selector: 'footer-button',
  templateUrl: 'footer-button.html'
})
export class FooterButtonComponent {

  hideFooter: boolean = false;
  @Input() disable: boolean;
  @Input() buttonText: string;
  @Input() linkText: string;
  @Input() showLink: boolean = false;
  @Input() backgroundColor: string;
  @Input() secondary: boolean;
  @Input() newFooter: boolean;
  @Input() newLink: boolean;
  @Output() actionEmitter = new EventEmitter<any>();
  @Output() linkEmitter = new EventEmitter<any>();

  hideObserver: Observable<any>;

  constructor(private events: Events, public keyboard: Keyboard, private cdRef: ChangeDetectorRef) {
    this.hideObserver = this.keyboard.onKeyboardHide();

    this.handledFooter();
  }
  
  handledFooter() {
    this.events.subscribe(EVENTS_NAME.HIDE_FOOTER, () => {
      if(typeof cordova != 'undefined') this.hideFooter = true
      });
    this.hideObserver.subscribe(() => {
      this.hideFooter = false
      this.cdRef.detectChanges();
    });
  }

  doAction() {
    this.actionEmitter.emit();
  }

  doLinkAction() {
    this.linkEmitter.emit();
  }

  getBackgroundColor() {
    let color = '';
    if(this.secondary) {
      color = ColorProvider.getColorValue('--gray-100');
    }
    else {
      if(this.disable) color = ColorProvider.getColorValue('--app-primary');
      else {
        if(this.backgroundColor) color = this.backgroundColor;
        else color = ColorProvider.getColorValue('--app-primary');
      }
    }
    return color;
  }

}



// WEBPACK FOOTER //
// ./src/components/myria/footer-button/footer-button.ts